export type Idp = "okta" | "entra";

export type WmsModule = "metrics" | "count";

export const OKTA_METRICS_GROUP = "WMS Admin - Metrics";
export const OKTA_COUNT_GROUP = "WMS Admin - Count";

export const ENTRA_METRICS_GROUP = "Entra-Reece-WMSAdminMetrics";
export const ENTRA_COUNT_GROUP = "Entra-Reece-WMSAdminCount";

export const UNAUTHORIZED_PATH = "/unauthorized";

export const getRequiredGroup = (module: WmsModule, idp: Idp): string => {
  if (idp === "entra") {
    return module === "metrics" ? ENTRA_METRICS_GROUP : ENTRA_COUNT_GROUP;
  }
  return module === "metrics" ? OKTA_METRICS_GROUP : OKTA_COUNT_GROUP;
};

export const hasModuleAccess = (
  groups: string[] | undefined,
  module: WmsModule,
  idp: Idp
): boolean => groups?.includes(getRequiredGroup(module, idp)) ?? false;

/** First landing route the user is allowed to see, or null when none apply. */
export const getLandingPath = (
  groups: string[] | undefined,
  idp: Idp
): string | null => {
  if (hasModuleAccess(groups, "metrics", idp)) {
    return "/metrics";
  }
  if (hasModuleAccess(groups, "count", idp)) {
    return "/count";
  }
  return null;
};
